module.exports = __webpack_public_path__ + "img/pop-up-empty-list-dark.e3adf7d9.svg";